import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Prioritate, PrioritateUpdate } from './prioritati.interface';

@Injectable({
    providedIn: 'root'
})
export class PrioritatiService {
    private basePath = environment.interop.basePath;

    private findUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.find;
    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.prioritati.updatePublic;

    constructor(private http: HttpClient) { }

    find(id: number) {
        return this.http.get(this.findUrl + id);
    }

    list() {
        return this.http.get(this.listUrl);
    }

    add(prioritate: Prioritate) {
        return this.http.post(this.storeUrl, prioritate);
    }

    update(prioritate: PrioritateUpdate) {
        return this.http.put(this.updateUrl, prioritate);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
